<app-view-item *ngIf="readonly" [text]="selected?.code" [borderless]="borderless"></app-view-item>

<nz-select
  *ngIf="!readonly"
  #selector
  nzShowSearch
  nzServerSearch
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event)"
  (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzAllowClear]="allowClear"
  [nzBackdrop]="addBackdrop"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  [nzDropdownRender]="renderTemplate"
  class="width-100"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>

  <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="o.code" nzCustomContent>
      <span>{{ o.code }}</span>
    </nz-option>
  </ng-container>
</nz-select>
<ng-template #renderTemplate>
  <div class="text-center" *ngIf="!this.NotShowInReport">
    <button type="button" nz-button nzType="primary" (click)="addNew()">
      <span nz-icon nzType="plus"></span>
      {{ instantData ? ' Add New \''+ instantData +'\'' : ' Add New' }}
    </button>
  </div>
</ng-template>
